import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import type { QueryClient } from '@tanstack/react-query';
import type { RouterContext } from './routes/__root';
import { ErrorFallback } from './components/error-fallback';
import { DefaultPending } from './components/default-pending';
import { authClient } from './lib/app-runtime';

export function createAppRouter(queryClient: QueryClient) {
  const context: RouterContext = {
    queryClient,
    auth: {
      get accessToken() {
        return authClient.getAccessToken();
      },
      get user() {
        return authClient.getUser();
      },
      get permissions() {
        return authClient.getPermissions();
      },
      login: authClient.login,
      logout: authClient.logout,
      refresh: authClient.refresh,
      ensurePermissions: authClient.ensurePermissions,
      callWithAuth: authClient.callWithAuth,
    },
  };

  return createRouter({
    routeTree,
    context,
    defaultErrorComponent: ErrorFallback,
    defaultPendingComponent: DefaultPending,
    defaultStructuralSharing: true,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
